import { FormikBag }            from 'formik'

import { FormikComponentProps } from '../types'

type TProxyFormikSubmission =
  <V, P extends FormikComponentProps<V, P>> (values: V, bag: FormikBag<P, V>) => void

const proxyFormikSubmission: TProxyFormikSubmission = (values, bag) => {
  bag.props.onSubmit(values, bag)
}

export default proxyFormikSubmission



// WEBPACK FOOTER //
// ./src/components/forms/form-utils/proxy-formik-submission.ts